import { useRef as L, useState as u, useEffect as q, useCallback as e } from "react";
const B = ({
  isClearingOnOutsideClick: f,
  setValue: o,
  items: n,
  value: p,
  openMenuAction: a
}) => {
  const C = L(null), [g, d] = u(!1), [A, c] = u(!1), [h, r] = u(!1);
  q(() => {
    n != null && n.length || r(!0), (n === void 0 || n != null && n.length) && r(!1);
  }, [p, n, r]);
  const s = e(() => {
    var t;
    c(!1), (t = C.current) == null || t.blur();
  }, []), S = e(() => {
    s(), f && o("");
  }, [s, f, o]), k = e(() => {
    o("");
  }, [s, o]), I = e(() => {
    o("");
  }, [o]), R = e((t) => {
    t.stopPropagation(), c((l) => !l);
  }, []), b = e(
    (t) => {
      o(t);
    },
    [o]
  ), x = e(() => {
    d(!0), a === "focus" && c(!0);
  }, [a]), F = e((t) => {
    var l;
    ((l = t.relatedTarget) == null ? void 0 : l.textContent) === " " && c(!1);
  }, []);
  return {
    focused: g,
    open: A,
    internalIsLoading: h,
    setOpen: c,
    onClickingOutSide: S,
    onNoResultClick: k,
    onAutocompleteClear: I,
    onAutoCompleteClick: R,
    onAutoCompleteSearch: b,
    onAutoCompleteFocus: x,
    onAutoCompleteBlur: F
  };
};
export {
  B as useAutoComplete
};
//# sourceMappingURL=index.es2368.js.map
